__turbopack_context__.v({
  "screen_reader_title": "styles-module-scss-module__XBkZ0a__screen_reader_title",
});
